import { z } from 'zod';
import Flake from '../flake/flake';
import { FlakePrefixes } from '../global-items/prefixes';
export function formatError(zodError) {
    return {
        errors: zodError.issues.map(function (issue) { return ({
            path: issue.path,
            message: issue.message,
            code: issue.code,
        }); }),
    };
}
export function createFlakeIdSchema(flakePrefix) {
    var type = Object.keys(FlakePrefixes).find(function (key) { return FlakePrefixes[key] === flakePrefix; });
    // TODO: Would be nice to give it a type of `${T}_${string}` but the current codebase isn't ready.
    return z.custom(function (value) { return typeof value === 'string' && Flake.isValid(value) && Flake.parse(value).type === type; }, {
        message: "Invalid ".concat(type, " Flake ID"),
    });
}
